import React from 'react';
import {
  EAutocompleteCategoryDefinitionProps,
  EAutocompleteOption,
} from 'webapp-lib/Components';

import casusBackend, {CasusSearchItem} from '@lexian/api/casus-api';
import i18n from '_/i18n';
import {CasusFlags} from '_/sharedComponents/CasusFlags';
import {SearchCasusFilters} from '_/types/casus';
import {handlePaginatedLoadableFetch} from '_/utilities/simple-fetch';
import {
  PageItem,
  PaginatedLoadable,
  PaginationArguments,
} from '_/utilities/types';

export function buildSearchCasus(
  paginationArguments: Omit<PaginationArguments, 'cursor'>,
  currentLoadable: PaginatedLoadable<PageItem<CasusSearchItem>[]>,
  {filters, searchQuery}: {filters: SearchCasusFilters; searchQuery: string}
): Promise<PaginatedLoadable<PageItem<CasusSearchItem>[]>> {
  return handlePaginatedLoadableFetch(
    {
      endpointFunction: casusBackend.searchAllCasus,
      otherParams: {...filters, query: searchQuery},
      getPageItemFromResponse: (body) => body.casus,
    },
    paginationArguments,
    currentLoadable
  );
}

export enum CasusCategoryNames {
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  FAVORITES = 'FAVORITES',
  OTHERS = 'OTHERS',
}

export const CASUS_CATEGORIES: EAutocompleteCategoryDefinitionProps[] = [
  {
    name: CasusCategoryNames.RECOMMENDATIONS,
    mainLabel: i18n.t('common:casusAutocomplete.categories.recommendations'),
  },
  {
    name: CasusCategoryNames.FAVORITES,
    mainLabel: i18n.t('common:casusAutocomplete.categories.favorites'),
  },
  {
    name: CasusCategoryNames.OTHERS,
    mainLabel: i18n.t('common:casusAutocomplete.categories.others'),
  },
];

function isAssignable(casus: {readonly: boolean}): boolean {
  return !casus.readonly;
}

export function mapToOption(
  casus: CasusSearchItem,
  disableUnassignableCasus: boolean
): EAutocompleteOption {
  return {
    displayText: casus.displayNameWithClient,
    value: casus.id,
    subtext: i18n.t('common:casusNumber', {casusNumber: casus.casusNumber}),
    categoryName: casus.isFavorite
      ? CasusCategoryNames.FAVORITES
      : CasusCategoryNames.OTHERS,
    endAdornment: (
      <CasusFlags
        isInternal={casus.internal}
        isLocked={casus.locked}
        isProtected={casus.protected}
        state={casus.state}
      />
    ),
    disabled: disableUnassignableCasus && !isAssignable(casus),
  };
}
